import React from 'react';
import style from './style.scss';
import {ListItemCategory} from './list-category-item';
import {SearchCategory} from './search-category';
import {CategoryMenu} from 'components/category';

class CategoryDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      title: 'Thiết bị mạng',
      data: [
        {
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        },{
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470 Brand New',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        },{
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        },{
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470 Brand New',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        },{
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470 Brand New',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        },{
          link: '/product/10',
          images: [
            "6acfdeb2-6f5b-4c58-bdc5-39ab4d26a926.jpg",
            "2c3ae1da-36d0-4cc4-bad3-33049e491096.jpg",
            "25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg",
            "6c666cdf-b6fc-441b-80a8-bde1b5a8084c.jpg",
            "a052e70c-3db5-4ba5-bbdc-a05198882462.jpg",
            "fd45de4d-d82f-46ff-ac43-8aeb9f9edc81.jpg"
          ],
          name: 'CPU Processor Intel Core i5 3470',
          price: 'GIÁ 60.000 - 150.000',
          description: 'Shenzhen South Legend Technology Company Limited',
          btnName: 'Gửi yêu cầu'
        }
      ]
    }
  }

  viewMore() {
    console.log('zô');
    let newItem = {
      link: '/product/10',
      image: {
        name: '25851a1c-68ab-4d93-9f79-a0839f5f8fa9.jpg'
      },
      name: 'CPU Processor Intel Core i5 3470',
      price: 'GIÁ 60.000 - 150.000',
      description: 'Shenzhen South Legend Technology Company Limited',
      btnName: 'Gửi yêu cầu'
    }
    this.setState({
      data: [
        ...this.state.data,
        newItem
      ]
    })
  }

  render() {
    return (
      <section className="center">
        <div className='category-detail'>
          <h2 className='title-category'>{this.state.title}</h2>
          <div className='wrap-category'>
            <div className='category-left-menu'>
              <CategoryMenu/>
            </div>
            <div className='category-center-content'>
              <ListItemCategory data={this.state.data}/>
              <button className='btn-viewmore-detail' onClick={this.viewMore.bind(this)}><span className='btn-viewmore-text'>Xem thêm</span></button>
            </div>
            <div className='category-right-search'>
              <SearchCategory/>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CategoryDetail;



// WEBPACK FOOTER //
// ./components/category-detail/CategoryDetail.jsx